import { Navigate } from "react-router-dom";

// Landing page after the SSO post-logout redirect. We forward to /login
// with a flash message so the user understands why they're back here.
export function LogoutCallbackPage() {
  return <Navigate to="/login?reason=logged_out" replace />;
}
